package app.nestbridge.app.di

import com.karawek.core.platform.PlatformContext
import kotlin.reflect.KClass
import me.tatarka.inject.annotations.Component
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.MergeComponent
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = AppComponent::class)
@Component
@MergeComponent(scope = AppScope::class)
@SingleIn(scope = AppScope::class)
public abstract class KotlinInjectAppComponent(
  platformContextDelegate: PlatformContext,
) : AppComponent(platformContextDelegate),
    KotlinInjectAppComponentMerged {
  public companion object
}

public fun KClass<AppComponent>.create(platformContextDelegate: PlatformContext): AppComponent = KotlinInjectAppComponent::class.create(platformContextDelegate)
